import React, {useContext} from "react";
import {AdvancedImage, AdvancedVideo, responsive} from '@cloudinary/react';
import ConditionalLink from "../../../ConditionalLink/ConditionalLink";
import Laurels from "../../../Laurels/Laurels";
import {ProjectsContext} from "../../../../App";
import './style.scss';

const ProjectCover = ({index, src , image, onClick, route}) => {
    const laurels = image.laurels;

    const imageData = image?.context?.custom;
    const title = imageData?.caption;
    const description= imageData?.alt;
    const name = imageData?.name;
    const subName= imageData?.subName;
    const vimeo= imageData?.vimeo;

    const {cld} = useContext(ProjectsContext);
    const projectType = (imageData?.type === 'cinematography' || imageData?.type === 'directing') ? 'movie' : 'project';
    const projectRoute = `/${image?.section || route}/${projectType}/${name}`;
    const myImage = cld.image(src);
    const myVideo = cld.video(src);
    const isVideo = image?.format === 'mp4';

    return (
        <ConditionalLink to={projectRoute} aria-label={`Open ${name || title}`} state={{src, description, title, subName, vimeo, laurels}} condition={title}>
            <div
                className={`image ${!title ? 'unlinked' : ''}`}
                onClick={event => {
                    if (!onClick) return;
                    const clickHandled = onClick(index, src);
                    if (clickHandled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}
            >
                {isVideo ? (
                    <AdvancedVideo
                        cldVid={myVideo}
                        className="cover"
                        autoPlay
                        loop
                        muted
                        controls={false}
                        playsInline
                    />
                ) : (
                    <AdvancedImage cldImg={myImage} plugins={[responsive({steps: 200})]} className='cover'/>
                )}
                {title &&
                    <div className='content'>
                        <div>
                            <p className='title'>{title}</p>
                            <p className='subName' dangerouslySetInnerHTML={{__html: subName}}></p>
                        </div>
                        {laurels && <Laurels laurels={laurels}/> }
                    </div>
                }
            </div>
        </ConditionalLink>
    )
}

export default ProjectCover;
